import React, { Component } from 'react';
import PropTypes from 'prop-types';  // eslint-disable-line
import _ from 'lodash';

import { pie, arc } from 'd3-shape';
import { scaleOrdinal } from 'd3-scale';
import { schemeSet1 } from 'd3-scale-chromatic';

import SVGContainer from './SVGContainer';

// import { threatStatesData } from './sampleData';

class PieChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterBy: 'priority',
    };

    this.filterBy = this.filterBy.bind(this);
    this.renderPieChart = this.renderPieChart.bind(this);
    this.renderFilter = this.renderFilter.bind(this);
    this.renderLegendPartFromData = this.renderLegendPartFromData.bind(this);
    this.renderLegend = this.renderLegend.bind(this);
  }

  filterBy(event) {
    this.setState({ filterBy: event.target.value });
  }

  renderPieChart(data, color) {
    const w = 90;

    const outerRadius = w / 2;
    const innerRadius = outerRadius - 15;

    const pieShape = pie()
      .value(d => d.percent)
      .sort(null)
      .padAngle(0.00);

    const arcShape = arc()
      .outerRadius(outerRadius)
      .innerRadius(innerRadius);

    return (
      <SVGContainer
        className='donut'
        width='30%'
      >
        <g transform='translate(50, 50)'>
          {_.map(pieShape(data), d => <path key={d.data.name} d={arcShape(d)} fill={color(d.data.name)} />)}
        </g>
      </SVGContainer>
    );
  }

  renderFilter() {
    return (
      <div
        className='filter'
        style={{
          width: '30%',
          display: 'inline-block',
          verticalAlign: 'top',
          textAlign: 'left',
        }}
      >
        <select
          style={{ fontSize: '11px', fontWeight: '300' }}
          onChange={this.filterBy.bind(this)}
        >
          <option value='priority'>By Priority</option>
          <option value='severity'>By Severity</option>
        </select>
      </div>
    );
  }

  renderLegendPartFromData(data, color, category, legendLabel, yOffset) {
    const legendKeys = data
      .filter(d => d.category === category)
      .map((d, i) => {
        const keysXOffset = 50 * i;

        return (
          <g
            key={`pie-chart-${category}-key-${i}`}
            transform={`translate(${keysXOffset}, 15)`}
          >
            <rect
              x='0'
              y='0'
              width='20'
              height='20'
              fill={color(d.name)}
            />
            <text
              x='25'
              y='16'
              style={{
                fontSize: '13px',
                fontWeight: '400',
                fill: '#333',
              }}
            >
              {d.value.toUpperCase()}
            </text>
          </g>
        );
      });

    return (
      <g transform={`translate(0, ${yOffset})`}>
        <text
          style={{
            fontSize: '13px',
            fontWeight: '300',
            fill: '#333',
            cursor: 'pointer',
          }}
        >
          { legendLabel }
        </text>
        { legendKeys }
      </g>
    );
  }

  renderLegend(data, filterBy, color) {
    const legendTitle = (
      <text
        x='0'
        y='0'
        style={{
          fontSize: '15px',
          fontWeight: '500',
          fill: '#333',
          cursor: 'pointer',
        }}
      >
        { filterBy.toUpperCase() }
      </text>
    );

    return (
      <SVGContainer
        className='legend'
        width='40%'
        viewBox='0 0 200 200'
      >
        <g transform='translate(0, 20)'>
          {legendTitle}
          {this.renderLegendPartFromData(data, color, 'suspects', 'Suspects', 25)}
          {this.renderLegendPartFromData(data, color, 'threats', 'Threats', 90)}
        </g>
      </SVGContainer>
    );
  }

  render() {
    const { filterBy } = this.state;

    const color = scaleOrdinal(schemeSet1);

    // stub pie chart data for testing
    // const data = threatStatesData[filterBy];

    const { visualizationData } = this.props;
    const data = visualizationData[filterBy];

    return (
      <div className='chart'>
        {this.renderPieChart(data, color)}
        {this.renderLegend(data, filterBy, color)}
        {/* this.renderFilter(data) */}
      </div>
    );
  }
}

PieChart.propTypes = {
  visualizationData: PropTypes.shape({}),
};

PieChart.defaultProps = {
  visualizationData: {},
};

export default PieChart;



// WEBPACK FOOTER //
// ./src/views/Components/Charts/PieChart.js